import { defineCustomElement } from '@tyler-components-web/core';
import { OpenIconComponent } from './open-icon';
export * from './open-icon-adapter';
export * from './open-icon-constants';
export * from './open-icon-foundation';
export * from './open-icon';
export function defineOpenIconComponent() {
    defineCustomElement(OpenIconComponent);
}
